import { AuthReducer, ExperimentsReducer, FirebaseReducer, LanguageReducer, StatsReducer } from '@web_opxp/features';
import { combineReducers } from 'redux';
import { AppReducer } from '../app';
import { CheckoutReducer } from '../checkout';
import { CouponReducer } from '../coupon';
import { ManageReducer } from '../manage';
import { OrdersReducer } from '../orders';
import { SubscribeReducer } from '../subscribe';

export default combineReducers({
  [AppReducer.statePropName]: AppReducer.default,
  [AuthReducer.statePropName]: AuthReducer.default,
  [SubscribeReducer.statePropName]: SubscribeReducer.default,
  [LanguageReducer.statePropName]: LanguageReducer.default,
  [StatsReducer.statePropName]: StatsReducer.default,
  [FirebaseReducer.statePropName]: FirebaseReducer.default,
  [CouponReducer.statePropName]: CouponReducer.default,
  [CheckoutReducer.statePropName]: CheckoutReducer.default,
  [ManageReducer.statePropName]: ManageReducer.default,
  [OrdersReducer.statePropName]: OrdersReducer.default,
  [ExperimentsReducer.statePropName]: ExperimentsReducer.default,
});
